module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.onClickaway),
      expression: "onClickaway"
    }],
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.clickList
    }
  }, [_c('div', {
    staticClass: "text-search"
  }, [_vm._v(_vm._s(_vm.dropdown_title))]), _c('span', {
    staticClass: "gray-bold-caret"
  }), (_vm.show_list) ? _c('div', {
    staticClass: "list-stages"
  }, _vm._l((_vm.list), function(item) {
    return (_vm.show_list) ? _c('div', {
      staticClass: "item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.clicked(item)
        }
      }
    }, [_c('div', {
      staticClass: "select-button",
      class: {
        'all_selected': item.selected
      }
    }), _c('div', {
      staticClass: "name-stage"
    }, [_vm._v(_vm._s(item.text))])]) : _vm._e()
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1633e455!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/dropdown_multiple_kind/stage_filter.vue
// module id = 1022
// module chunks = 1